import { useEffect, useState, type CSSProperties } from 'react';
import { getColorsHidden, onColorsPrefChange } from '../../utils/ColorPrefs';
import './PilotBadge.css';

type PilotBadgeProps = {
  name: string;
  color?: string | null;
  className?: string;
  style?: CSSProperties;
};

const isHexColor = (color?: string | null) =>
  Boolean(color && /^#[0-9A-Fa-f]{6}$/i.test(color));

const classNames = (...parts: Array<string | undefined>) =>
  parts.filter(Boolean).join(' ');

const PilotBadge = ({ name, color, className, style }: PilotBadgeProps) => {
  const [hideColors, setHideColors] = useState(getColorsHidden);

  useEffect(() => onColorsPrefChange(() => setHideColors(getColorsHidden())), []);

  if (hideColors || !isHexColor(color)) {
    return (
      <span className={classNames('pilot-name', className)} style={style}>
        {name}
      </span>
    );
  }

  return (
    <span
      className={classNames('pilot-badge', className)}
      style={{ backgroundColor: color as string, ...style }}
    >
      {name}
    </span>
  );
};

export default PilotBadge;
